import { Link } from "react-router-dom";
import { subUrl } from "../../helper/globals";
export default function Footer() {
  function showCurrentYear() {
    return new Date().getFullYear();
  }
  return (
    <footer>
      <div className="row">
        <ul>
          <li>
            <Link to={subUrl + "helpdesk"}>Help</Link>
          </li>
          <li className="ver-line">
            <a href>|</a>
          </li>
          <li>
            <Link to={subUrl + "contact"}>Contact</Link>
          </li>
          <li className="ver-line">
            <a href>|</a>
          </li>
          <li>
            <a href="https://ddishtv.mn">Монгол</a>
          </li>
          <li className="text-right">&#169;{showCurrentYear()} DDISH</li>
        </ul>
      </div>
    </footer>
  );
}
